import http from '@/plugins/axios/axios';
import { CHVAE_TOKEN } from '@/global';

export default class ClienteIKAcessoService {

    constructor() {
        this.baseUrl = process.env.VUE_APP_BASE_URL_ADMIN_IKACESSO;        
        this.token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN)); 
    }

    salvar(requisicao) {       
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/cliente/salvar',
            data: requisicao
        });
    }

    alterar(requisicao) {       
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/cliente/alterar',
            data: requisicao
        });
    }

    buscar(id) {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/cliente/buscar/'+id,
        });
    }

    listarTodos() {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/cliente/listarTodos'
        });
    }

    salvarLicenca(requisicao) {
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/licenca/salvar',
            data: requisicao
        });
    }

    alterarLicenca(requisicao) {
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/licenca/alterar',
            data: requisicao
        });
    }

    excluirLicenca(licenca) {
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/licenca/excluir',
            data: licenca
        });
    }

    reenviarEmailLicenca(requisicao) {
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/licenca/reenviarEmailLicenca',
            data: requisicao
        });
    }

    listarLicencas(idCliente) {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/api/licenca/listarPorCliente/'+idCliente
        });
    }

}